"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The main unit of a Gantt chart
 */
var Task = /** @class */ (function () {
    /**
     * @param title - The title of this task
     * @param url - The URL to this task (directly usable in an `<a>` href)
     * @param start - A start date, which is mandatory without a predecessor
     * @param due - A due date (if start set, defaults to start + 1 day)
     * @param predecessor - The parent of this task, which might be used to override the start date
     */
    function Task(title, url, start, due, predecessor) {
        this.title = title;
        this.url = url;
        this.start = start;
        this.due = due;
        this.predecessor = predecessor;
        if (!predecessor && !start) {
            throw new Error('A Task with no predecessor must have a start date');
        }
        if (!due && start) {
            var calculatedDue = new Date(start);
            calculatedDue.setDate(calculatedDue.getDate() + 1);
            this.due = calculatedDue;
        }
    }
    return Task;
}());
exports.Task = Task;
//# sourceMappingURL=Task.js.map